import type { GridInitialState } from '@mui/x-data-grid-pro';

const NUMBER_FIELD = 'number';
const CURRENT_VERSION_FIELD = 'currentVersion';

/**
 * Migration (PT-7117): places the new `currentVersion` documentation column
 * right after `number` in the user's saved column order (appended when
 * `number` is missing). No-op when the column is already saved.
 */
export function addCurrentVersionColumn(
  state: GridInitialState
): { next: GridInitialState; changed: boolean } {
  const original = state.columns?.orderedFields;
  if (!original?.length || original.includes(CURRENT_VERSION_FIELD)) {
    return { next: state, changed: false };
  }

  const idxNumber = original.indexOf(NUMBER_FIELD);
  const ordered =
    idxNumber === -1
      ? [...original, CURRENT_VERSION_FIELD]
      : [
          ...original.slice(0, idxNumber + 1),
          CURRENT_VERSION_FIELD,
          ...original.slice(idxNumber + 1),
        ];

  return {
    next: {
      ...state,
      columns: {
        ...state.columns,
        orderedFields: ordered,
      },
    },
    changed: true,
  };
}
